import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Loader from "../Loader/Loader";
import WebService from "../utility/WebService";

interface propData {
    data: any;
    isShow: boolean;
    isClose: any;
}

const TermsCondition = (props: propData) => {
    const [description, setDescription] = useState('');
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (props.isShow) {
            getTermsCondition()
        }
    }, [props.isShow])

    const getTermsCondition = () => {
        setLoading(true)
        WebService.getAPI({
            action: `api/Invoice/terms/${props.data}`
        })
            .then((res: any) => {
                setDescription(res.description)
                setLoading(false)
            })
            .catch((e) => {
                setLoading(false)
            })
    }

    const onCloseModal = (e?: any) => {
        props.isClose(!props.isShow, e)
    };

    return (
        <>
            <Loader show={isLoading} />
            <Offcanvas
                show={props.isShow}
                onHide={onCloseModal}
                placement={"end"}
                className="offcanvas-large"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Terms & Conditions</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="border-bottom px-0 information-main-view ">
                    <div className="px-3 form-style preview-main" dangerouslySetInnerHTML={{ __html: description }}>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default TermsCondition;